export default function ServiceArea() {
  const orangeCountyCities = [
    'Irvine', 'Newport Beach', 'Costa Mesa', 'Huntington Beach',
    'Anaheim', 'Santa Ana', 'Laguna Beach', 'Mission Viejo',
    'Lake Forest', 'San Clemente', 'Dana Point', 'Aliso Viejo',
    'Rancho Santa Margarita',
  ];

  const coachellaValleyCities = [
    'Indio', 'Palm Desert', 'La Quinta', 'Palm Springs', 'Cathedral City',
  ];

  return (
    <section id="service-area" className="py-24 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block bg-amber-500/20 text-amber-400 px-4 py-2 rounded-full text-sm font-semibold mb-4 border border-amber-500/30">
            Service Coverage
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold mb-6">
            Proudly Serving All of Southern California
          </h2>
          <p className="text-xl text-white/80">
            From Orange County to the Coachella Valley and everywhere in between—plus long-distance moves nationwide.
          </p>
        </div>

        {/* Main Service Areas Grid */}
        <div className="grid lg:grid-cols-2 gap-8 mb-12">
          {/* Orange County Card */}
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20 hover:bg-white/15 transition-all">
            <div className="flex items-start gap-4 mb-6">
              <div className="w-14 h-14 bg-amber-500 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-map-pin-fill text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold mb-2">Orange County</h3>
                <p className="text-white/70">Your trusted movers across all OC communities</p>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-3">
              {orangeCountyCities.map((city, index) => (
                <div key={index} className="flex items-center gap-2 text-white/90">
                  <i className="ri-map-pin-line text-amber-400 text-sm"></i>
                  <span className="text-sm">{city}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Coachella Valley Card */}
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20 hover:bg-white/15 transition-all">
            <div className="flex items-start gap-4 mb-6">
              <div className="w-14 h-14 bg-sky-500 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-map-pin-fill text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold mb-2">Coachella Valley</h3>
                <p className="text-white/70">Desert communities we proudly serve</p>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-3">
              {coachellaValleyCities.map((city, index) => (
                <div key={index} className="flex items-center gap-2 text-white/90">
                  <i className="ri-map-pin-line text-sky-400 text-sm"></i>
                  <span className="text-sm">{city}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Long Distance Banner */}
        <div className="bg-gradient-to-r from-amber-500 to-amber-600 rounded-2xl p-8 sm:p-12 text-center mb-12 shadow-2xl">
          <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
            <i className="ri-roadster-line text-3xl text-white"></i>
          </div>
          <h3 className="text-3xl font-bold text-white mb-4">
            Long-Distance Moving Nationwide
          </h3>
          <p className="text-lg text-white/90 max-w-2xl mx-auto mb-6">
            Planning a move across state lines? We provide professional long-distance moving services to any destination in the United States. Your belongings are safe with us, no matter how far you're going.
          </p>
          <a 
            href="#quote-form" 
            className="inline-flex items-center justify-center bg-white text-amber-600 px-8 py-4 rounded-lg font-bold hover:bg-gray-100 transition-colors whitespace-nowrap shadow-lg"
          >
            Get Long-Distance Quote
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </div>

        {/* Operating Hours & Contact */}
        <div className="grid md:grid-cols-3 gap-6">
          <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10 text-center">
            <div className="w-12 h-12 bg-emerald-500/20 rounded-lg flex items-center justify-center mx-auto mb-3">
              <i className="ri-time-line text-2xl text-emerald-400"></i>
            </div>
            <div className="font-bold text-lg mb-2">Business Hours</div>
            <div className="text-white/70">Monday - Sunday</div>
            <div className="text-white/70">9:00 AM - 5:00 PM</div>
          </div>

          <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10 text-center">
            <div className="w-12 h-12 bg-sky-500/20 rounded-lg flex items-center justify-center mx-auto mb-3">
              <i className="ri-phone-line text-2xl text-sky-400"></i>
            </div>
            <div className="font-bold text-lg mb-2">Call Us Anytime</div>
            <a href="tel:7606257767" className="text-white/90 hover:text-white block">(760) 625-7767</a>
            <a href="tel:5624553028" className="text-white/90 hover:text-white block">(562) 455-3028</a>
            <a href="tel:7603472727" className="text-white/90 hover:text-white block">(760) 347-2727</a>
          </div>

          <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10 text-center">
            <div className="w-12 h-12 bg-violet-500/20 rounded-lg flex items-center justify-center mx-auto mb-3">
              <i className="ri-question-answer-line text-2xl text-violet-400"></i>
            </div>
            <div className="font-bold text-lg mb-2">Not Sure We Serve You?</div>
            <div className="text-white/70 mb-3">Contact us to confirm coverage in your area</div>
            <a 
              href="#quote-form" 
              className="text-amber-400 hover:text-amber-300 font-semibold inline-flex items-center"
            >
              Ask Us
              <i className="ri-arrow-right-line ml-1"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}